import { AdminPortal } from '@frontegg/react';

import Typography from '~/shared/components/Typography';
import Button from '~/shared/components/Buttons';

export function AdminButton(): JSX.Element {
  return (
    <Button
      className="w-fit px-2 py-1 border border-gray-400 h-9 "
      variant="tertiary"
      // size=""
      onClick={() => {
        AdminPortal?.show();
      }}
    >
      <Typography
        variant="p3"
        fontWeight={600}
        color="text-primary-900 leading-5 normal-case font-family-inter"
      >
        Admin portal
      </Typography>
    </Button>
  );
}
